// extracted by mini-css-extract-plugin
export default {"paginator":"Pagination_paginator__DKJys","arrow":"Pagination_arrow__Wkrri","selected":"Pagination_selected__45633"};